import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, token, loadUser } = useContext(AuthContext);
  const [checkedAuth, setCheckedAuth] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(false);
  
  // Try to revalidate authentication if there's a token but not authenticated
  useEffect(() => {
    
    // If we have a token but aren't authenticated, try to load the user
    const validateAuth = async () => {
      if (!checkedAuth && !isCheckingAuth && !loading && !isAuthenticated && localStorage.getItem('token')) {
        
        setIsCheckingAuth(true);
        
        try {
          await loadUser();
        } catch (err) {
          
        } finally {
          setIsCheckingAuth(false);
          setCheckedAuth(true);
        }
      } else if (!loading) {
        // Mark as checked if we're not loading
        setCheckedAuth(true);
      }
    };
    
    validateAuth();
  }, [isAuthenticated, loading, token, loadUser, checkedAuth, isCheckingAuth]);
  
  // Show loading indicator while checking authentication
  if (loading || isCheckingAuth || !checkedAuth) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to login if not authenticated after checks
  if (!isAuthenticated) {
    // Store the current location to redirect back after login
    const currentPath = window.location.pathname;
    
    // Only store the redirect path if we're not already on the login page
    if (currentPath !== '/login') {
      localStorage.setItem('redirectAfterLogin', currentPath);
    }
    
    return <Navigate to="/login" />;
  }
  
  // User is authenticated, render children
  
  return children;
};

export default PrivateRoute;
